import { render, staticRenderFns } from "./PromoTabContainer.vue?vue&type=template&id=dec7a004&lang=pug&"
import script from "./PromoTabContainer.vue?vue&type=script&lang=js&"
export * from "./PromoTabContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports